module.exports = __webpack_public_path__ + "0513414c2a39a225f021be70037ff72a.jpg";